/* eslint-disable import/prefer-default-export */
export { default as Comment } from './Comment';
